export default __webpack_public_path__ + "img/unpaid-invoice.e8c97bb8.svg";